export enum JabraValidation {
  StringLengthValidator = '{83E96D09-11C8-4132-8A8A-76D8DB8208D6}',
}
